import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

type Section = {
  id: string;
  text: string;
  element: HTMLElement;
};

interface TocProps {
  containerRef: React.RefObject<HTMLElement | null>;
}

export const Toc = ({ containerRef }: TocProps) => {
  const [ sections, setSections ] = useState<Section[]>([])
  const { t: t } = useTranslation('common')
  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const headings = Array.from(container.querySelectorAll('h3'))
    const result = headings.map((el, index) => {
      const id = `section-${index}`
      el.setAttribute('id', id)
      return {
        id,
        text: el.textContent || `Раздел ${index + 1}`,
        element: el,
      }
    })

    setSections(result)
  }, [ containerRef ])

  const scrollTo = (el: HTMLElement) => {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return (
    <nav className={styles.root}>
      <h5>{t('content')}</h5>
      {sections.map((s) => (
        <span key={s.id} onClick={() => scrollTo(s.element)}>
          {s.text}
        </span>
      ))}
    </nav>
  )
}
